import React from 'react'

interface LightbulbIconProps {
  size?: number
  className?: string
}

export const LightbulbIcon: React.FC<LightbulbIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 9.33C10.13 8.67 10.47 8.2 11 7.67C11.67 7.07 12 6.2 12 5.33C12 4.27 11.58 3.25 10.83 2.5C10.08 1.75 9.06 1.33 8 1.33C6.94 1.33 5.92 1.75 5.17 2.5C4.42 3.25 4 4.27 4 5.33C4 6 4.13 6.8 5 7.67C5.47 8.13 5.87 8.67 6 9.33M6 12H10M6.67 14.67H9.33"
      stroke="#EAB308"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
